/* eslint-disable lingui/no-unlocalized-strings -- rótulos que o legado manda no fio (`<campo>Display`), não texto de UI */
// Valores técnicos e rótulos de fio da Gestão SPI, lidos do legado `UYZY@d999fc0be`
// (`pages/BankAccount/SPIManagement/SPIConsult/SPIConsultForm.tsx:19-48`). Os rótulos vão no fio como
// `<campo>Display`, então são literais do legado, não texto de UI (o texto da tela passa pelo Lingui).

export const SPI_PATH = '/contas-digitais/gestao-spi';
export const SPI_CONSULT_PATH = '/contas-digitais/gestao-spi/consultas';

interface WireOption {
  readonly value: string;
  /** Rótulo que o `SelectFormField` grava em `<campo>Display` (`SelectFormField.tsx:113-119`). */
  readonly label: string;
}

/** "Tipo de operação" (`SPIConsultForm.tsx:19-26`). */
export const MESSAGE_GROUP_OPTIONS = [
  { value: '1', label: 'PACS' },
  { value: '2', label: 'LPI' },
  { value: '3', label: 'Todas' },
  { value: '4', label: 'Externo' },
  { value: '5', label: 'Interno' },
  { value: '6', label: 'Conta PI' },
] as const satisfies readonly WireOption[];

/** "Enviado/Recebido" (`SPIConsultForm.tsx:28-32`). */
export const OPERATION_TYPE_OPTIONS = [
  { value: '1', label: 'Crédito' },
  { value: '2', label: 'Débito' },
  { value: '3', label: 'Todas' },
] as const satisfies readonly WireOption[];

/** "Status da mensagem" (`SPIConsultForm.tsx:34-39`). */
export const OPERATION_STATUS_OPTIONS = [
  { value: '1', label: 'Aprovada' },
  { value: '2', label: 'Em Trânsito' },
  { value: '3', label: 'Recusada' },
  { value: '4', label: 'Todas' },
] as const satisfies readonly WireOption[];

/** "Tipo Pix" (`SPIConsultForm.tsx:41-48`). */
export const PIX_TYPE_OPTIONS = [
  { value: '1', label: 'Todas' },
  { value: '2', label: 'Devolução' },
  { value: '3', label: 'MED' },
  { value: '4', label: 'TROCO' },
  { value: '5', label: 'SAQUE' },
  { value: '6', label: 'TRANSFERENCIA' },
] as const satisfies readonly WireOption[];

export const MESSAGE_GROUP_VALUES = MESSAGE_GROUP_OPTIONS.map((option) => option.value) as unknown as ['1', '2', '3', '4', '5', '6'];
export const OPERATION_TYPE_VALUES = OPERATION_TYPE_OPTIONS.map((option) => option.value) as unknown as ['1', '2', '3'];
export const OPERATION_STATUS_VALUES = OPERATION_STATUS_OPTIONS.map((option) => option.value) as unknown as ['1', '2', '3', '4'];
export const PIX_TYPE_VALUES = PIX_TYPE_OPTIONS.map((option) => option.value) as unknown as ['1', '2', '3', '4', '5', '6'];

const labelOf = (options: readonly WireOption[], value: string | undefined) => options.find((option) => option.value === value)?.label;

export const messageGroupWireLabel = (value: string | undefined) => labelOf(MESSAGE_GROUP_OPTIONS, value);
export const operationTypeWireLabel = (value: string | undefined) => labelOf(OPERATION_TYPE_OPTIONS, value);
export const operationStatusWireLabel = (value: string | undefined) => labelOf(OPERATION_STATUS_OPTIONS, value);
export const pixTypeWireLabel = (value: string | undefined) => labelOf(PIX_TYPE_OPTIONS, value);

/** Status "Aprovada" da coluna Status: o único em verde no legado (`SPIConsultFormList.tsx:38,118`). */
export const STATUS_APPROVED = 'Aprovada';
